import React from 'react';
import {Router, Switch, Route, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import createBrowserHistory from 'history/createBrowserHistory';

import { routes } from './routesConfig';

const history = createBrowserHistory();

class AppRouter extends React.Component {

    render() {

        if (history.location.pathname !== '/') {
            // if (this.props.authData === undefined || this.props.authData === null ) {
            if (this.props.userId === "") {
                history.push('/');
            }
        }

        return (
            <Router history={history}>
                <Switch>

                    {
                        routes.map((item, index) => {

                            return (
                                <Route
                                    key={index.toString()}
                                    exact path={item.path}
                                    component={withRouter((props) => {
                                        let Component = item.component;
                                        return (
                                            <Component
                                                // authData={this.props.authData}
                                                // currentProject={this.props.currentProjectData}
                                                {...props}
                                            />
                                        )
                                    })}
                                />
                            )

                        })
                    }


                    {/*<Route*/}
                    {/*    path='/'*/}
                    {/*    component={LoginScreen}		// change back to LoginScreen*/}
                    {/*/>*/}

                </Switch>
            </Router>
        )
    }
}

const mapStateToProps = state => {
    return {
        userId: state.user.userId,
        authData: state.auth.authData
    }
};

export default connect(mapStateToProps, null)(AppRouter);

// export default connect(mapStateToProps, null)(AppRouter);
